import React, {useState, useEffect, Suspense, useLayoutEffect} from "react";

// react-router components
import {Routes, Route, Navigate, useLocation, useNavigate, Outlet} from "react-router-dom";
import IconButton from '@mui/material/IconButton';

// @mui material components
import {createTheme, ThemeProvider} from "@mui/material/styles";
import {useDispatch, useSelector} from "react-redux";
import CssBaseline from "@mui/material/CssBaseline";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React example components
import Sidenav from "examples/Sidenav";
import Configurator from "examples/Configurator";

// Material Dashboard 2 React themes
import theme from "assets/theme";


// Material Dashboard 2 React Dark Mode themes
import themeDark from "assets/theme-dark";

// RTL plugins

import SettingsIcon from '@mui/icons-material/Settings';

// Material Dashboard 2 React routes


// Material Dashboard 2 React contexts

// Images
import brandWhite from "assets/images/logos/darwynn/darwynn_logo.svg";
import brandDark from "assets/images/logos/darwynn/dark_logo.svg";
import {useTranslation} from "react-i18next";
import {
    onErrorAlert,
    setCache,
    setCurrentRoutes,
    setDarkMode,
    setLanguage,
    setMiniSidenav,
    setOpenConfigurator, setSidenavColor,
    setTransparentSidenav, setWhiteSidenav
} from "./actions";
import LocalStorage from "./utils/LocalStorage";
import adminRoutes from "./adminRoutes";
import {LOCAL_STORAGE_ITEMS} from "./constants";
import SkeletonCard from "./components/MuiSkeleton";
import {filterRoutes} from "./utils/globalFunction";
import NotFoundPage from "./examples/NotFound/NotFoundPage";
import AuthLayout from "./examples/LayoutContainers/AuthLayout";
import {enUS, zhCN,frFR} from "@mui/x-data-grid/locales";
import i18n from "i18next";
import {fixed} from "lodash/fp/_falseOptions";
import MDTypography from "./components/MDTypography";
import AuthSyncListener from './utils/AuthSyncListener';

export default function App() {

    const dispatch = useDispatch()
    const {t} = useTranslation();

    const [onMouseEnter, setOnMouseEnter] = useState(false);
    const {pathname} = useLocation();
    const darkMode = useSelector(state => state?.common?.darkMode)
    const transparentSidenav = useSelector(state => state?.common?.transparentSidenav)
    const miniSidenav = useSelector(state => state?.common?.miniSidenav)
    const whiteSidenav = useSelector(state => state?.common?.whiteSidenav)
    const sidenavColor = useSelector(state => state?.common?.sidenavColor)
    const direction = useSelector(state => state?.common?.direction)
    const layout = useSelector(state => state?.common?.layout)
    const openConfigurator = useSelector(state => state?.common?.openConfigurator)
    const loading = useSelector(state => state?.auth.loading)
    const currentRoutes = useSelector(state => state?.auth?.currentRoutes)
    const menuList = useSelector(state => state?.auth.menuList)
    const nav = useNavigate()
    const isAdmin = useSelector(state => state?.auth.userType) === 'admin'
    const language = useSelector(state => state?.common?.language)

    useEffect(() => {
        //获取setting
        //获取menu

        if(LocalStorage.getItem('setting')){
            const setting = JSON.parse(LocalStorage.getItem('setting'))
            dispatch(setDarkMode(setting?.darkMode))
            dispatch(setTransparentSidenav(setting?.transparentSidenav))
            dispatch(setWhiteSidenav(setting?.whiteSidenav))
            dispatch(setSidenavColor(setting?.sidenavColor))
            dispatch(setCache(setting?.cache))
            i18n.changeLanguage(setting?.language)
        }


        if(LocalStorage.getItem('keys') && LocalStorage.getItem('menu')){
            dispatch(setCurrentRoutes(filterRoutes([...adminRoutes], JSON.parse(LocalStorage.getItem('keys')))))
        } else {
             return nav('/')
        }
        // const lang = LocalStorage.getItem('i18nextLng')
        // dispatch(setLanguage(lang))

        //删除存储的打开的tabs index
        LocalStorage.removeItem('selectedInventoryStockTab')
        LocalStorage.removeItem('selectedKitManagementTab')
        LocalStorage.removeItem('selectedPackagingTab')
        LocalStorage.removeItem('selectedSalesReportsTab')
        LocalStorage.removeItem('selectedFulfillmentReportsTab')
        LocalStorage.removeItem('selectedInventoryReportsTab')
        LocalStorage.removeItem('selectedAccountTab')
        LocalStorage.removeItem('selectedPriceSettingTab')
        LocalStorage.removeItem('selectedWarehouseTab')

    }, [])

    useEffect(() => {
        if (LocalStorage.getItem("setting")) {
            const setting = JSON.parse(LocalStorage.getItem("setting"));
            dispatch(setDarkMode(setting?.darkMode));
        }
        // const currentLang = LocalStorage.getItem("i18nextLng") || "en";
        // console.log('currentLang',currentLang)
        // i18n.changeLanguage(currentLang); // 默认英文
        // dispatch(setLanguage(currentLang));
    }, [dispatch]);

    // useEffect(() => {
    //     const lang = LocalStorage.getItem("i18nextLng") || "en"; // Defaults to English if not found
    //     dispatch(setLanguage(lang));
    //     i18n.changeLanguage(lang);
    // }, []); // This effect runs only once on component mount

    // useEffect(() => {
    //     const lang = LocalStorage.getItem("i18nextLng")
    //     console.log("Setting language on load:", lang);
    //     dispatch(setLanguage(lang));
    //     i18n.changeLanguage(lang);
    // }, []);




    // Open sidenav when mouse enter on mini sidenav


    // Change the openConfigurator state



    // Setting the dir attribute for the body element
    useEffect(() => {
        document.body.setAttribute("dir", direction);
    }, [direction]);

    // Setting page scroll to 0 when changing the route
    useEffect(() => {
        document.documentElement.scrollTop = 0;
        document.scrollingElement.scrollTop = 0;
    }, [pathname]);

    // const LazyComponent = (path) => React.lazy(() => import(`${path}`));

    // Leaf routes are generated flat (no nested <Route>/<Outlet> for parent groups like
    // Outbounds/Inventory/Integration/Report/Billing). A nested <Outlet/> always resolves to
    // whatever route is *currently* matched app-wide, so when AuthLayout's KeepAlive keeps two
    // sibling tabs (e.g. Wholesale and E-commerce) mounted at once, their shared inner <Outlet/>
    // would only reflect whichever one is currently active, leaving the other blank/stale.
    // Wrapping the leaf component into its parent group's chrome (route.component) directly
    // avoids the shared-Outlet dependency, so each cached tab is a fully self-contained element.
    const getRoutesAuth = (allRoutes, parentPath = "/app", wrappers = []) =>

        allRoutes.flatMap((route) => {
            const absoluteRoutePath = `${parentPath}${route.route}`;
            if (route.collapse) {
                return getRoutesAuth(route.collapse, parentPath, wrappers);
            }

            if (route.route && !route.children) {
                if (!!LocalStorage.getToken()) {
                    const element = wrappers.reduceRight(
                        (child, wrapper) => React.cloneElement(wrapper, {}, child),
                        route.component
                    );
                    return [<Route exact path={absoluteRoutePath} element={<Suspense fallback={<div></div>}>{element}</Suspense>} key={route.key}/>];

                } else {
                    return [];
                }
            }

            if (route.children) {
                return getRoutesAuth(route.children, absoluteRoutePath, [...wrappers, route.component]);
            }

            return [];
        });


    const getRoutesNotAuth = (allRoutes) =>

        allRoutes.map((route) => {

            if (route.collapse) {
                return getRoutesNotAuth(route.collapse);
            }

            if (route.route && !route.children) {
                return <Route exact path={route.route} element={route.component} key={route.key}/>;
            }

            if (route.route && route.children) {
                return <Route path={route.route} element={route.component} key={route.key}>
                    {route.children.map(child =>
                        <Route path={`${route.route}${child.route}`} element={child.component} key={child.key}/>)}
                </Route>
            }

            return null;
        });


   const [cookieFlag,setCookieFlag] = useState(LocalStorage.getItem('cookieFlag'));

    const checkTokenRedirect = () => {
        const token = LocalStorage.getToken()
        return token ? <NotFoundPage /> : <Navigate to="/authentication/sign-in" />;
    };



    return (
        <ThemeProvider theme={createTheme(darkMode ? themeDark : theme,
            language === "zh" ? zhCN : language === "fr" ? frFR : enUS)}>
            <CssBaseline/>


            {/*{layout === "vr" && <Configurator/>}*/}
            <AuthSyncListener />
            <Routes>

                <Route path="/app" element={<AuthLayout />}>
                    {getRoutesAuth(currentRoutes.filter(route => route.isAuth))}
                </Route>

                {getRoutesNotAuth(adminRoutes.filter(route => !route.isAuth))}
                <Route path="/" element={<Navigate to="/authentication/sign-in"/>}/>
                {/*<Route path="*" element={<NotFoundPage />} />*/}
                <Route path="*" element={checkTokenRedirect()} />
            </Routes>
        </ThemeProvider>
    );
}
